<template>
  <b-row
    align-v="center"
    class="justify-content-between"
    :style="{ 'min-height': '70px' }"
  >
    <b-col
      class="col-auto pt-3"
      :style="creatingExam ? { width: '405px' } : null"
    >
      <b-form-group v-if="!innerValue.isShortAnswer">
        <span class="tsny_text-mid mr-5">{{ index + 1 }}</span>
        <span
          class="tsny_radio-group"
          v-for="choice in computedChoices"
          :key="choice"
        >
          <input
            class="tsny_radio"
            type="radio"
            v-model="innerValue.correctChoice"
            :value="choice"
            :id="choice + ':' + innerValue.key"
            @click="multipleChoiceHandler(choice)"
          /><label
            class="tsny_radio-label tsny_text"
            :style="[{ 'padding-left': choice === 'J' ? '12px' : '9px' }]"
            :for="choice + ':' + innerValue.key"
            >{{ choice }}</label
          >
        </span>
      </b-form-group>
      <b-form-group v-if="innerValue.isShortAnswer">
        <b-input-group>
          <span class="tsny_text-mid mr-5">{{ index + 1 }}</span>
          <div v-if="!creatingExam">
            <b-select
              class="form-control short_answer"
              v-for="(n, shortAnswerIndex) in 4"
              :key="shortAnswerIndex"
              v-model="innerValue.shortAnswer[shortAnswerIndex]"
              :options="shortAnswerChoices(shortAnswerIndex)"
            />
          </div>
          <div v-if="creatingExam">
            <div
              v-for="(shortAnswerOptionGroup,
              groupIndex) in innerValue.shortAnswerOptions"
              :key="groupIndex"
            >
              <b-select
                class="form-control short_answer"
                v-for="(n, shortAnswerIndex) in 4"
                :key="shortAnswerIndex"
                v-model="shortAnswerOptionGroup[shortAnswerIndex]"
                :options="shortAnswerChoices(shortAnswerIndex)"
              />
              <i
                class="fas fa-trash tsny_icon"
                @click="removeShortAnswerOption(groupIndex)"
              />
            </div>
          </div>
          <div v-if="creatingExam" class="ml-5">
            <b-button @click="addShortAnswerOption">+</b-button>
          </div>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col class="col-auto" v-if="creatingExam">
      <b-form-group label="Category:" label-cols="auto"
        ><b-form-select
          v-if="categoryOptions"
          class="form-control"
          v-model="innerValue.category"
          :options="categoryOptions"
      /></b-form-group>
    </b-col>
    <b-col class="col-auto" v-if="creatingExam">
      <b-form-group label="Sub-category:" label-cols="auto"
        ><b-form-select
          v-if="subcategoryOptions"
          class="form-control"
          v-model="innerValue.subcategory"
          :options="subcategoryOptions"
      /></b-form-group>
    </b-col>
    <b-col class="col-auto" v-if="creatingExam"
      ><i class="fa fa-trash fa-fw tsny_link" @click="$emit('delete-question')"
    /></b-col>
  </b-row>
</template>

<script>
import { _ } from "vue-underscore";

export default {
  name: "ExamQuestion",
  props: {
    value: {
      type: null,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    numChoices: {
      type: Number,
      default: 4
    },
    choices: {
      type: Array,
      default: () => ["A", "B", "C", "D"]
    },
    hasShortAnswer: {
      type: Boolean,
      default: null
    },
    creatingExam: {
      type: Boolean,
      default: false
    },
    categoryOptions: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      innerValue: null,
      previouslySelected: null
    };
  },
  computed: {
    computedChoices() {
      if (this.numChoices < this.choices.length) {
        return this.index % 2 === 0
          ? this.choices.slice(0, this.numChoices)
          : this.choices.slice(this.numChoices, this.numChoices.length);
      }
      return this.choices.slice(0, this.numChoices);
    },
    subcategoryOptions() {
      return this.innerValue && this.innerValue.category
        ? (
            _.findWhere(this.categoryOptions, {
              value: this.innerValue.category
            }) || {}
          ).subcategories
        : [];
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
      this.previouslySelected = this.innerValue.correctChoice;
      // remove the correct answers so the student can fill in the scantron
      if (!this.creatingExam) {
        this.innerValue.correctChoice = null;
        this.previouslySelected = null;
        this.innerValue.shortAnswer = [null, null, null, null];
      }
    } else
      this.innerValue = {
        key: Math.random(),
        shortAnswer: [null, null, null, null], // to initialize the '?' in our short answer inputs
        shortAnswerOptions: [[null, null, null, null]]
      };
  },
  watch: {
    innerValue(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    multipleChoiceHandler(value) {
      if (value === this.previouslySelected) {
        this.innerValue.correctChoice = null;
        this.previouslySelected = null;
      } else {
        this.previouslySelected = value;
      }
    },
    shortAnswerChoices(index) {
      let options = [
        { text: "?", value: null },
        ".",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9"
      ];

      if (index === 1 || index === 2) {
        options.splice(1, 0, "/");
        options.splice(3, 0, "0");
      }

      if (index === 3) {
        options.splice(2, 0, "0");
      }

      return options;
    },
    addShortAnswerOption() {
      this.innerValue.shortAnswerOptions.push([null, null, null, null]);
    },
    removeShortAnswerOption(index) {
      this.innerValue.shortAnswerOptions.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.tsny_radio {
  display: none;
}

.tsny_radio-label {
  width: 30px;
  height: 30px;
  padding-top: 3px;
  border: solid 1px black;
  border-radius: 50%;
  margin-right: 25px;
  transition: all 0.3s;
}

.tsny_radio-group input[type="radio"]:checked + .tsny_radio-label {
  color: white;
  background: #6b6b6b;
}

.tsny_radio-label:hover {
  cursor: pointer;
}

.short_answer {
  background: transparent;
  padding: 0;
  width: 30px;
  max-height: 30px;
  margin-right: 25px;
  text-align: center;
  text-align-last: center;
}
</style>
